/* eslint-disable */
import type { CallContext, CallOptions } from "nice-grpc-common";
import * as _m0 from "protobufjs/minimal";
import { BoolValue, StringValue } from "./google/protobuf/wrappers";
import { Empty } from "./util";
import Long = require("long");

export const protobufPackage = "escrow";

export interface EscrowedAssetFilter {
  escrowAccounts: string[];
  assetMint: string | undefined;
  custodian: string | undefined;
  availableOnly: boolean | undefined;
  principal: boolean | undefined;
}

export interface GetOnchainEscrowedAssetsAndUpdateDBRequest {
  filter: EscrowedAssetFilter | undefined;
  group: string;
}

export interface GetOnchainEscrowedAssetsAndUpdateDBResponse {
  assets: EscrowedAsset[];
}

export interface InsertEscrowRequest {
  asset: EscrowedAsset | undefined;
  group: string;
  escrowNonce: string;
  txnId: string;
}

export interface EscrowedAsset {
  id: number;
  mint: string;
  escrowAccountAddress: string;
  escrower: string;
  amount: number;
  lastInteractedTime: number;
}

function createBaseEscrowedAssetFilter(): EscrowedAssetFilter {
  return {
    escrowAccounts: [],
    assetMint: undefined,
    custodian: undefined,
    availableOnly: undefined,
    principal: undefined,
  };
}

export const EscrowedAssetFilter = {
  encode(message: EscrowedAssetFilter, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.escrowAccounts) {
      writer.uint32(10).string(v!);
    }
    if (message.assetMint !== undefined) {
      StringValue.encode({ value: message.assetMint! }, writer.uint32(18).fork()).ldelim();
    }
    if (message.custodian !== undefined) {
      StringValue.encode({ value: message.custodian! }, writer.uint32(26).fork()).ldelim();
    }
    if (message.availableOnly !== undefined) {
      BoolValue.encode({ value: message.availableOnly! }, writer.uint32(34).fork()).ldelim();
    }
    if (message.principal !== undefined) {
      BoolValue.encode({ value: message.principal! }, writer.uint32(42).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): EscrowedAssetFilter {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEscrowedAssetFilter();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.escrowAccounts.push(reader.string());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.assetMint = StringValue.decode(reader, reader.uint32()).value;
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.custodian = StringValue.decode(reader, reader.uint32()).value;
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.availableOnly = BoolValue.decode(reader, reader.uint32()).value;
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.principal = BoolValue.decode(reader, reader.uint32()).value;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EscrowedAssetFilter {
    return {
      escrowAccounts: globalThis.Array.isArray(object?.escrowAccounts)
        ? object.escrowAccounts.map((e: any) => globalThis.String(e))
        : [],
      assetMint: isSet(object.assetMint) ? String(object.assetMint) : undefined,
      custodian: isSet(object.custodian) ? String(object.custodian) : undefined,
      availableOnly: isSet(object.availableOnly) ? Boolean(object.availableOnly) : undefined,
      principal: isSet(object.principal) ? Boolean(object.principal) : undefined,
    };
  },

  toJSON(message: EscrowedAssetFilter): unknown {
    const obj: any = {};
    if (message.escrowAccounts?.length) {
      obj.escrowAccounts = message.escrowAccounts;
    }
    if (message.assetMint !== undefined) {
      obj.assetMint = message.assetMint;
    }
    if (message.custodian !== undefined) {
      obj.custodian = message.custodian;
    }
    if (message.availableOnly !== undefined) {
      obj.availableOnly = message.availableOnly;
    }
    if (message.principal !== undefined) {
      obj.principal = message.principal;
    }
    return obj;
  },

  create(base?: DeepPartial<EscrowedAssetFilter>): EscrowedAssetFilter {
    return EscrowedAssetFilter.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<EscrowedAssetFilter>): EscrowedAssetFilter {
    const message = createBaseEscrowedAssetFilter();
    message.escrowAccounts = object.escrowAccounts?.map((e) => e) || [];
    message.assetMint = object.assetMint ?? undefined;
    message.custodian = object.custodian ?? undefined;
    message.availableOnly = object.availableOnly ?? undefined;
    message.principal = object.principal ?? undefined;
    return message;
  },
};

function createBaseGetOnchainEscrowedAssetsAndUpdateDBRequest(): GetOnchainEscrowedAssetsAndUpdateDBRequest {
  return { filter: undefined, group: "" };
}

export const GetOnchainEscrowedAssetsAndUpdateDBRequest = {
  encode(message: GetOnchainEscrowedAssetsAndUpdateDBRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.filter !== undefined) {
      EscrowedAssetFilter.encode(message.filter, writer.uint32(10).fork()).ldelim();
    }
    if (message.group !== "") {
      writer.uint32(18).string(message.group);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetOnchainEscrowedAssetsAndUpdateDBRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetOnchainEscrowedAssetsAndUpdateDBRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.filter = EscrowedAssetFilter.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.group = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetOnchainEscrowedAssetsAndUpdateDBRequest {
    return {
      filter: isSet(object.filter) ? EscrowedAssetFilter.fromJSON(object.filter) : undefined,
      group: isSet(object.group) ? globalThis.String(object.group) : "",
    };
  },

  toJSON(message: GetOnchainEscrowedAssetsAndUpdateDBRequest): unknown {
    const obj: any = {};
    if (message.filter !== undefined) {
      obj.filter = EscrowedAssetFilter.toJSON(message.filter);
    }
    if (message.group !== "") {
      obj.group = message.group;
    }
    return obj;
  },

  create(base?: DeepPartial<GetOnchainEscrowedAssetsAndUpdateDBRequest>): GetOnchainEscrowedAssetsAndUpdateDBRequest {
    return GetOnchainEscrowedAssetsAndUpdateDBRequest.fromPartial(base ?? {});
  },
  fromPartial(
    object: DeepPartial<GetOnchainEscrowedAssetsAndUpdateDBRequest>,
  ): GetOnchainEscrowedAssetsAndUpdateDBRequest {
    const message = createBaseGetOnchainEscrowedAssetsAndUpdateDBRequest();
    message.filter = (object.filter !== undefined && object.filter !== null)
      ? EscrowedAssetFilter.fromPartial(object.filter)
      : undefined;
    message.group = object.group ?? "";
    return message;
  },
};

function createBaseGetOnchainEscrowedAssetsAndUpdateDBResponse(): GetOnchainEscrowedAssetsAndUpdateDBResponse {
  return { assets: [] };
}

export const GetOnchainEscrowedAssetsAndUpdateDBResponse = {
  encode(message: GetOnchainEscrowedAssetsAndUpdateDBResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.assets) {
      EscrowedAsset.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetOnchainEscrowedAssetsAndUpdateDBResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetOnchainEscrowedAssetsAndUpdateDBResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.assets.push(EscrowedAsset.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetOnchainEscrowedAssetsAndUpdateDBResponse {
    return {
      assets: globalThis.Array.isArray(object?.assets) ? object.assets.map((e: any) => EscrowedAsset.fromJSON(e)) : [],
    };
  },

  toJSON(message: GetOnchainEscrowedAssetsAndUpdateDBResponse): unknown {
    const obj: any = {};
    if (message.assets?.length) {
      obj.assets = message.assets.map((e) => EscrowedAsset.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<GetOnchainEscrowedAssetsAndUpdateDBResponse>): GetOnchainEscrowedAssetsAndUpdateDBResponse {
    return GetOnchainEscrowedAssetsAndUpdateDBResponse.fromPartial(base ?? {});
  },
  fromPartial(
    object: DeepPartial<GetOnchainEscrowedAssetsAndUpdateDBResponse>,
  ): GetOnchainEscrowedAssetsAndUpdateDBResponse {
    const message = createBaseGetOnchainEscrowedAssetsAndUpdateDBResponse();
    message.assets = object.assets?.map((e) => EscrowedAsset.fromPartial(e)) || [];
    return message;
  },
};

function createBaseInsertEscrowRequest(): InsertEscrowRequest {
  return { asset: undefined, group: "", escrowNonce: "", txnId: "" };
}

export const InsertEscrowRequest = {
  encode(message: InsertEscrowRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.asset !== undefined) {
      EscrowedAsset.encode(message.asset, writer.uint32(10).fork()).ldelim();
    }
    if (message.group !== "") {
      writer.uint32(18).string(message.group);
    }
    if (message.escrowNonce !== "") {
      writer.uint32(26).string(message.escrowNonce);
    }
    if (message.txnId !== "") {
      writer.uint32(34).string(message.txnId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): InsertEscrowRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInsertEscrowRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.asset = EscrowedAsset.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.group = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.escrowNonce = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.txnId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): InsertEscrowRequest {
    return {
      asset: isSet(object.asset) ? EscrowedAsset.fromJSON(object.asset) : undefined,
      group: isSet(object.group) ? globalThis.String(object.group) : "",
      escrowNonce: isSet(object.escrowNonce) ? globalThis.String(object.escrowNonce) : "",
      txnId: isSet(object.txnId) ? globalThis.String(object.txnId) : "",
    };
  },

  toJSON(message: InsertEscrowRequest): unknown {
    const obj: any = {};
    if (message.asset !== undefined) {
      obj.asset = EscrowedAsset.toJSON(message.asset);
    }
    if (message.group !== "") {
      obj.group = message.group;
    }
    if (message.escrowNonce !== "") {
      obj.escrowNonce = message.escrowNonce;
    }
    if (message.txnId !== "") {
      obj.txnId = message.txnId;
    }
    return obj;
  },

  create(base?: DeepPartial<InsertEscrowRequest>): InsertEscrowRequest {
    return InsertEscrowRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<InsertEscrowRequest>): InsertEscrowRequest {
    const message = createBaseInsertEscrowRequest();
    message.asset = (object.asset !== undefined && object.asset !== null)
      ? EscrowedAsset.fromPartial(object.asset)
      : undefined;
    message.group = object.group ?? "";
    message.escrowNonce = object.escrowNonce ?? "";
    message.txnId = object.txnId ?? "";
    return message;
  },
};

function createBaseEscrowedAsset(): EscrowedAsset {
  return { id: 0, mint: "", escrowAccountAddress: "", escrower: "", amount: 0, lastInteractedTime: 0 };
}

export const EscrowedAsset = {
  encode(message: EscrowedAsset, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.id !== 0) {
      writer.uint32(8).uint32(message.id);
    }
    if (message.mint !== "") {
      writer.uint32(18).string(message.mint);
    }
    if (message.escrowAccountAddress !== "") {
      writer.uint32(26).string(message.escrowAccountAddress);
    }
    if (message.escrower !== "") {
      writer.uint32(34).string(message.escrower);
    }
    if (message.amount !== 0) {
      writer.uint32(40).uint64(message.amount);
    }
    if (message.lastInteractedTime !== 0) {
      writer.uint32(48).int64(message.lastInteractedTime);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): EscrowedAsset {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEscrowedAsset();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.id = reader.uint32();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.mint = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.escrowAccountAddress = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.escrower = reader.string();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.amount = longToNumber(reader.uint64() as Long);
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.lastInteractedTime = longToNumber(reader.int64() as Long);
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EscrowedAsset {
    return {
      id: isSet(object.id) ? globalThis.Number(object.id) : 0,
      mint: isSet(object.mint) ? globalThis.String(object.mint) : "",
      escrowAccountAddress: isSet(object.escrowAccountAddress) ? globalThis.String(object.escrowAccountAddress) : "",
      escrower: isSet(object.escrower) ? globalThis.String(object.escrower) : "",
      amount: isSet(object.amount) ? globalThis.Number(object.amount) : 0,
      lastInteractedTime: isSet(object.lastInteractedTime) ? globalThis.Number(object.lastInteractedTime) : 0,
    };
  },

  toJSON(message: EscrowedAsset): unknown {
    const obj: any = {};
    if (message.id !== 0) {
      obj.id = Math.round(message.id);
    }
    if (message.mint !== "") {
      obj.mint = message.mint;
    }
    if (message.escrowAccountAddress !== "") {
      obj.escrowAccountAddress = message.escrowAccountAddress;
    }
    if (message.escrower !== "") {
      obj.escrower = message.escrower;
    }
    if (message.amount !== 0) {
      obj.amount = Math.round(message.amount);
    }
    if (message.lastInteractedTime !== 0) {
      obj.lastInteractedTime = Math.round(message.lastInteractedTime);
    }
    return obj;
  },

  create(base?: DeepPartial<EscrowedAsset>): EscrowedAsset {
    return EscrowedAsset.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<EscrowedAsset>): EscrowedAsset {
    const message = createBaseEscrowedAsset();
    message.id = object.id ?? 0;
    message.mint = object.mint ?? "";
    message.escrowAccountAddress = object.escrowAccountAddress ?? "";
    message.escrower = object.escrower ?? "";
    message.amount = object.amount ?? 0;
    message.lastInteractedTime = object.lastInteractedTime ?? 0;
    return message;
  },
};

export type EscrowServiceDefinition = typeof EscrowServiceDefinition;
export const EscrowServiceDefinition = {
  name: "EscrowService",
  fullName: "escrow.EscrowService",
  methods: {
    getOnchainEscrowedAssetsAndUpdateDB: {
      name: "GetOnchainEscrowedAssetsAndUpdateDB",
      requestType: GetOnchainEscrowedAssetsAndUpdateDBRequest,
      requestStream: false,
      responseType: GetOnchainEscrowedAssetsAndUpdateDBResponse,
      responseStream: false,
      options: {},
    },
    insertEscrow: {
      name: "InsertEscrow",
      requestType: InsertEscrowRequest,
      requestStream: false,
      responseType: Empty,
      responseStream: false,
      options: {},
    },
  },
} as const;

export interface EscrowServiceImplementation<CallContextExt = {}> {
  getOnchainEscrowedAssetsAndUpdateDB(
    request: GetOnchainEscrowedAssetsAndUpdateDBRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<GetOnchainEscrowedAssetsAndUpdateDBResponse>>;
  insertEscrow(request: InsertEscrowRequest, context: CallContext & CallContextExt): Promise<DeepPartial<Empty>>;
}

export interface EscrowServiceClient<CallOptionsExt = {}> {
  getOnchainEscrowedAssetsAndUpdateDB(
    request: DeepPartial<GetOnchainEscrowedAssetsAndUpdateDBRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<GetOnchainEscrowedAssetsAndUpdateDBResponse>;
  insertEscrow(request: DeepPartial<InsertEscrowRequest>, options?: CallOptions & CallOptionsExt): Promise<Empty>;
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
